import { render, staticRenderFns } from "./CardGChart.vue?vue&type=template&id=2dfbe6bd&scoped=true&"
import script from "./CardGChart.vue?vue&type=script&lang=js&"
export * from "./CardGChart.vue?vue&type=script&lang=js&"
import style0 from "./CardGChart.vue?vue&type=style&index=0&id=2dfbe6bd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dfbe6bd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
